// Notification dropdown — pulls /notifications from backend.
import { useEffect, useState } from "react";
import { api } from "../shared/api/client";
import { I } from "../shared/Icon";

type Notification = {
  id: number;
  type: string;
  title: string;
  body: string | null;
  link: string | null;
  is_read: boolean;
  created_at: string;
};

export function NotifPanel({ onClose }: { onClose: () => void }) {
  const [items, setItems] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get<Notification[]>("/notifications?limit=20")
      .then((r) => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  const markAll = async () => {
    await api.post("/notifications/read", { all: true });
    setItems((arr) => arr.map((n) => ({ ...n, is_read: true })));
  };

  return (
    <>
      <div style={{ position: "absolute", inset: 0, zIndex: 55 }} onClick={onClose}/>
      <div className="t-drop">
        <div className="t-drop-h">
          <h4>알림</h4>
          <button className="clear" onClick={markAll}>모두 읽음</button>
        </div>
        <div className="t-drop-body">
          {loading && <div style={{ padding: 20, textAlign: "center", color: "var(--text-3)" }}>불러오는 중…</div>}
          {!loading && items.length === 0 && (
            <div style={{ padding: 20, textAlign: "center", color: "var(--text-3)" }}>알림이 없습니다</div>
          )}
          {items.map((n) => (
            <div key={n.id} className={`t-drop-item ${!n.is_read ? "unread" : ""}`}>
              <div className="ico" style={{ background: "var(--p-600)" }}>
                <I.Bell size={14}/>
              </div>
              <div style={{ flex: 1 }}>
                <div className="body"><strong>{n.title}</strong></div>
                {n.body && <div className="body">{n.body}</div>}
                <div className="when">{new Date(n.created_at).toLocaleString("ko-KR")}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
